/* eslint-disable import/prefer-default-export */
function submitForm ($form, opts = {}) {
  const data = new FormData($form);
  /* eslint-disable no-underscore-dangle */
  const method = ($form._method && $form._method.value) || $form.method;
  /* eslint-enable no-underscore-dangle */

  return $.ajax({
    data,
    method,
    url: $form.action,
    processData: false,
    contentType: false,
    cache: false,
    ...opts,
  });
}

export default submitForm;
